import React from 'react';
import ImportacoesListPage from "../../components/importacoes/ImportacoesListPage";

export default function Index() {
    return (
        <ImportacoesListPage
            title="Demonstrações contábeis"
            subtitle="Histórico de importações de demonstrações contábeis."
            listEndpoint="listar/importacoes/demonstracoes"
            importarPath="/demonstracoes-contabeis/importar-guias"
            detalhesPath="/demonstracoes-contabeis/detalhes-importacao"
        />
    );
}
